'use strict';
var base = require('../product/base');
var focusHelper = require('base/components/focus');
var recommendationIntercept = require('./recommendationIntercept');
var utils = require('lyonscg/util/utils');
var imagesloaded = require('imagesloaded');
var carouselsBonusProduct = require('../components/carousels');


/**
 * Removes currency from formatted money string
 * @param {string} moneyString - the formatted money string
 * @returns {number} unformatted money value
 */
function unformatMoney(moneyString) {
    if (!moneyString) return 0;
    return Number(moneyString.replace(/[^0-9.-]+/g, ''));
}

/**
 * updates checkout buttons
 * @param {Object} data - AJAX response from the server
 */
function updateCheckoutButtons(data) {
    var $payPalButtonsContainer = $('.cart-paypal-button-container');
    var $affirmButtonsContainer = $('.affirm-cart-buttons-container');
    if (data && data.valid && data.valid.error) {
        $('.checkout-btn').addClass('disabled');
        $payPalButtonsContainer.addClass('d-none');
        $affirmButtonsContainer.addClass('d-none');
    } else {
        $('.checkout-btn').removeClass('disabled');
        $payPalButtonsContainer.removeClass('d-none');
        $affirmButtonsContainer.removeClass('d-none');
    }

    if (data && data.autoShip && !$payPalButtonsContainer.hasClass('d-none')) {
        $payPalButtonsContainer.addClass('d-none');
        $affirmButtonsContainer.addClass('d-none');
    } else if (data && !data.autoShip && data.valid && !data.valid.error) {
        $payPalButtonsContainer.removeClass('d-none');
        $affirmButtonsContainer.removeClass('d-none');
    }

    if (data && data.valid && data.valid.validOrderTotal) {
        $('.cart-order-threshold').addClass('d-none');
        $('.pet-donation-card').removeClass('d-none');
        $('.cart-shipping-method-selection').removeClass('d-none');
    } else {
        $('.cart-order-threshold').removeClass('d-none');
        $('.pet-donation-card').addClass('d-none');
        $('.cart-shipping-method-selection').addClass('d-none');
    }
}

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
    if (data.valid.error) {
        if (data.valid.message) {
            var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
                'fade show" role="alert">' +
                '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
                '<span aria-hidden="true">&times;</span>' +
                '</button>' + data.valid.message + '</div>';

            $('.cart-error').append(errorHtml);
        } else {
            $('.cart').empty().append('<div class="row"> ' +
                '<div class="col-12 text-center"> ' +
                '<h1>' + data.resources.emptyCartMsg + '</h1> ' +
                '</div> ' +
                '</div>'
            );
            $('.number-of-items').empty().append(data.resources.numberOfItems);
            $('.minicart-quantity').empty().append(data.numItems);
            $('.minicart-link').attr({
                'aria-label': data.resources.minicartCountOfItems,
                title: data.resources.minicartCountOfItems
            });
            $('.minicart .popover').empty();
            $('.minicart .popover').removeClass('show');
        }
    } else {
        $('.cart-error').empty();
    }
}

/**
 * re-renders the shipping EDD in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateEDD(data) {
    var lastEnd;
    data.data.items.forEach(function (item) {
        if (!item.isPetDonationProduct) {
            // get its start date span
            var startSelector = '.product-line-edd-start-' + item.UUID;
            $(startSelector).empty().append(item.edd.edd_begin_formatted);

            // determine if we need to show end date
            var endSelector = '.product-line-edd-end-' + item.UUID;
            $(endSelector).empty();
            if (item.edd.edd_begin !== item.edd.edd_end) {
                $(endSelector).append('- ' + item.edd.edd_end_formatted);
            }

            try {
                var eddEnd = new Date(item.edd.edd_end);
                if (!lastEnd || eddEnd > lastEnd) {
                    lastEnd = eddEnd;
                }
            } catch (e) {
                window.bslLog(e);
            }
        }
    });

    window.logEstimatedDeliveryDate(lastEnd);

    // update calculated
    $('.estimated-delivery-dates-calculated-range').empty().append(data.narvarEDD.narvarCalculatedRange);
}

window.logEstimatedDeliveryDate = function logEstimatedDeliveryDate(dEstimatedDeliveryDate) {
    if (!dEstimatedDeliveryDate) return;
    try {
        var datToday = new Date(new Date().toJSON().slice(0, 10));
        var endDiff = parseInt(((new Date(dEstimatedDeliveryDate)).getTime() - datToday.getTime()) / (1000 * 3600 * 24), 10);

        window.bslLog('EstimatedDeliveryDateUpdate:' + dEstimatedDeliveryDate + ', ' + endDiff);
        if (endDiff > 0) {
            var curDiff = parseInt(window.bslReadDL('EstimatedDeliveryDays'), 10);
            if (curDiff !== endDiff) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ event: 'EstimatedDeliveryDateUpdate', EstimatedDeliveryDays: endDiff });
            }
        }
    } catch (e) {
        window.bslLog(e);
    }
};

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
    if (data.cartTotalsHtml) {
        $('.js-cart-totals').empty().append(data.cartTotalsHtml);
    }
    if (data.cartPromoCodesHtml) {
        $('.js-cart-promo-code').empty().append(data.cartPromoCodesHtml);
    }
    $('.number-of-items').empty().append(data.resources.numberOfItems);
    $('.shipping-cost').empty().append(data.totals.totalShippingCost);
    $('.tax-total').empty().append(data.totals.totalTax);
    $('.grand-total-sum').empty().append(data.totals.grandTotal);
    $('.sub-total').empty().append(data.totals.subTotal);
    $('.shippingMethods option:selected').text($('.shippingMethods option:selected').text().split('-')[0] + ' - ' + data.totals.totalShippingCost);
    $('.minicart-link').attr({
        'aria-label': data.resources.minicartCountOfItems,
        title: data.resources.minicartCountOfItems
    });
    var estimatedArrivalMsg = $('.shippingMethods option:selected').attr('data-estimated-arrival');
    $('.estimated-arrival-time').empty().append(estimatedArrivalMsg);

    var isFreeShipping = data.totals && data.totals.shippingLevelDiscountTotal && data.totals.shippingLevelDiscountTotal.isFreeShipping;
    if (isFreeShipping) {
        $('.free-ship-block').removeClass('d-none').addClass('d-block');
    } else {
        $('.free-ship-block').removeClass('d-block').addClass('d-none');
    }

    var totalCalculated = unformatMoney(data.totals.grandTotal);
    /* Affirm block for refreshing promo message */
    $('.affirm-as-low-as').attr('data-amount', (totalCalculated * 100).toFixed());
    if (window.affirm && typeof window.affirm.jsReady === 'function' && window.affirm.jsReady()) {
        window.affirm.ui.refresh();
    }

    $('.minicart-quantity').empty().append(data.numItems);

    if (data.totals.orderLevelDiscountTotal.value > 0) {
        $('.order-discount').removeClass('hide-order-discount');
        $('.order-discount-total').empty()
            .append('- ' + data.totals.orderLevelDiscountTotal.formatted);
    } else {
        $('.order-discount').addClass('hide-order-discount');
    }

    if (data.totals.shippingLevelDiscountTotal.value > 0) {
        $('.shipping-discount').removeClass('hide-shipping-discount');
        $('.shipping-discount-total').empty().append('- ' +
            data.totals.shippingLevelDiscountTotal.formatted);
    } else {
        $('.shipping-discount').addClass('hide-shipping-discount');
    }

    data.items.forEach(function (item) {
        $('.item-' + item.UUID).empty().append(item.renderedPromotions);
        $('.item-total-' + item.UUID).empty().append(item.priceTotal.renderedPrice);
        $('.item-rewards-points-' + item.UUID).empty().append(item.priceTotal.renderedRewardsPoints);
        $('.line-item-price-' + item.UUID).find('.js-product-price').empty().append(item.price.html);
        $('.product-line-item[data-product-line-item=' + item.UUID + ']').find('.js-product-price').empty().append(item.price.html);
    });

    var $totalSavingsContainer = $('.total-savings-container');
    if ($totalSavingsContainer.length && data.totals.totalSavings && data.totals.totalSavings.formatted) {
        $totalSavingsContainer.find('.total-savings').empty().append(data.totals.totalSavings.formatted);
        if (data.totals.totalSavings.value !== 0) {
            $totalSavingsContainer.removeClass('d-none');
        } else {
            $totalSavingsContainer.addClass('d-none');
        }
    }
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
        'fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' + message + '</div>';

    $('.cart-error').append(errorHtml);
}

/**
 * Generate and display Bootstrap Toast
 * @param {string} message - Message to display in the toast
 * @param {string} type - Type of the toast (success, danger, etc.)
 */
function showToast(message, type) {
    var toast = '<div class="alert re-alert re-alert-' + type + ' alert-dismissible fade show position-fixed w-100 rounded-0" role="alert">'
        + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
        + '<span aria-hidden="true">&times;</span>'
        + '</button>'
        + '<span class="text-white">' + message + '</span>'
        + '</div>';
    $('body').append(toast);
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
    var html = '';

    if (approachingDiscounts.length > 0) {
        $('.promotion-information').empty();
        if (!$('.promotion-information').length) {
            $('.coupons-and-promos').prepend('<div class="promotion-information"></div>');
        }
        approachingDiscounts.forEach(function (item) {
            html += '<div class="promotion-discount-show text-center">' + item.discountMsg;
            if (item.barProgress) {
                html += '<div class="discount-bar"><div class="bar-block"><span class="values from">$' + item.barFromValue + '</span>'
                + '<div class="bar-inside" style="width:' + item.barProgress + '%"></div>'
                + '<span class="values to">$' + item.barToValue + '</span>'
                + '</div></div>';
            }
            html += '</div>';
        });
    }
    $('.promotion-information').append(html);
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
    var lineItem;
    var messages = '';

    for (var i = 0; i < data.items.length; i++) {
        if (data.items[i].UUID === uuid) {
            lineItem = data.items[i];
            break;
        }
    }

    $('.availability-' + lineItem.UUID).empty();

    if (lineItem.availability) {
        if (lineItem.availability.messages) {
            lineItem.availability.messages.forEach(function (message) {
                messages += '<p class="line-item-attributes">' + message + '</p>';
            });
        }

        if (lineItem.availability.inStockDate) {
            messages += '<p class="line-item-attributes line-item-instock-date">'
                + lineItem.availability.inStockDate
                + '</p>';
        }
    }

    $('.availability-' + lineItem.UUID).html(messages);
}

/**
 * Finds an element in the array that matches search parameter
 * @param {array} array - array of items to search
 * @param {function} match - function that takes an element and returns a boolean indicating if the match is made
 * @returns {Object|null} - returns an element of the array that matched the query.
 */
function findItem(array, match) {
    for (var i = 0, l = array.length; i < l; i++) {
        if (match.call(this, array[i])) {
            return array[i];
        }
    }
    return null;
}

/**
 * Updates details of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateProductDetails(data, uuid) {
    var lineItem = findItem(data.cartModel.items, function (item) {
        return item.UUID === uuid;
    });

    if (lineItem.variationAttributes) {
        var colorAttr = findItem(lineItem.variationAttributes, function (attr) {
            return attr.attributeId === 'color';
        });

        if (colorAttr) {
            var colorSelector = '.Color-' + uuid;
            var newColor = 'Color: ' + colorAttr.displayValue;
            $(colorSelector).text(newColor);
        }

        var sizeAttr = findItem(lineItem.variationAttributes, function (attr) {
            return attr.attributeId === 'size';
        });

        if (sizeAttr) {
            var sizeSelector = '.Size-' + uuid;
            var newSize = 'Size: ' + sizeAttr.displayValue;
            $(sizeSelector).text(newSize);
        }

        var imageSelector = '.card.product-info.uuid-' + uuid + ' .item-image > img';
        $(imageSelector).attr('src', lineItem.images.small[0].url);
        $(imageSelector).attr('alt', lineItem.images.small[0].alt);
        $(imageSelector).attr('title', lineItem.images.small[0].title);
    }

    var qtySelector = '.quantity[data-uuid="' + uuid + '"]';
    $(qtySelector).val(lineItem.quantity);
    $(qtySelector).data('pid', data.newProductId);

    $('.remove-product[data-uuid="' + uuid + '"]').data('pid', data.newProductId);

    var priceSelector = '.line-item-price-' + uuid + ' .sales .value';
    $(priceSelector).text(lineItem.price.sales.formatted);
    $(priceSelector).attr('content', lineItem.price.sales.decimalPrice);

    if (lineItem.price.list) {
        var listPriceSelector = '.line-item-price-' + uuid + ' .list .value';
        $(listPriceSelector).text(lineItem.price.list.formatted);
        $(listPriceSelector).attr('content', lineItem.price.list.decimalPrice);
    }
}

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#editProductModal').length !== 0) {
        $('#editProductModal').remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="editProductModal" tabindex="-1" role="dialog">'
        + '<div class="modal-dialog quick-view-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} editProductUrl - url to be used to retrieve a new product model
 */
function fillModalElement(editProductUrl) {
    $('.modal-body').spinner().start();
    $.ajax({
        url: editProductUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);

            $('#editProductModal .modal-body').empty();
            $('#editProductModal .modal-body').html(parsedHtml.body);
            $('#editProductModal .modal-footer').html(parsedHtml.footer);
            $('#editProductModal .modal-header .close .sr-only').text(data.closeButtonText);
            $('#editProductModal').modal('show');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to remove product
 * @param {string} productID - pid
 * @param {string} productName - product name
 * @param {string} uuid - uuid
 */
function confirmDelete(actionUrl, productID, productName, uuid) {
    var $deleteConfirmBtn = $('.cart-delete-confirmation-btn');
    var $productToRemoveSpan = $('.product-to-remove');

    $deleteConfirmBtn.data('pid', productID);
    $deleteConfirmBtn.data('action', actionUrl);
    $deleteConfirmBtn.data('uuid', uuid);

    $productToRemoveSpan.empty().append(productName);
}

/**
 * Retrieve donation product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getDonationOptions($productContainer) {
    var options = $productContainer
        .find('.donation-option')
        .map(function () {
            var $elOption = $('.donationAmount.active', $(this));
            var selectedValueId = $elOption.data('value-id');

            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        }).toArray();

    return JSON.stringify(options);
}

/**
 * If coupon is valid but not applicable to the current cart, remove it
 * @param {Object} data - AJAX response from the server
 * @return {boolean} - true if an invalid coupon was found and removed, false otherwise
* */
function removeCartInvalidCoupon(data) {
    var invalidCartCoupon = data.totals.discounts.find(function (discount) {
        return discount.type === 'coupon' && discount.applied === false;
    });
    if (!invalidCartCoupon) return false;

    var urlParams = {
        code: invalidCartCoupon.couponCode,
        uuid: invalidCartCoupon.UUID
    };
    var removeCouponLineItemUrl = appendToUrl(data.actionUrls.removeCouponLineItem, urlParams);

    $.ajax({
        url: removeCouponLineItemUrl,
        type: 'GET',
        dataType: 'json',
        success: function (removeData) {
            updateCartTotals(removeData);
            $('#coupon-code-input-modal').modal('hide');
            $.spinner().stop();
            showToast(data.resources.invalidCouponRemovedMsg, 'danger');
        },
        error: function () {
            showToast(data.resources.couponRemovedErrorMsg, 'danger');
        },
        complete: function () {
            $('#coupon-code-input-modal').modal('hide');
            $.spinner().stop();
        }
    });
    return true;
}

/**
 * Submits "add coupon" form
 * @param {boolean} deleteExistingCoupons - flag for if existing coupons should be deleted
 */
function submitAddCartCoupon(deleteExistingCoupons) {
    var $form = $('.promo-code-form');
    $('.promo-code-form .form-control').removeClass('is-invalid');
    $('.promo-code-form label[for="couponCode"]').removeClass('invalid-label');
    $('.coupon-error-message').empty();

    var url = $form.attr('action');
    if (deleteExistingCoupons) {
        url = appendToUrl(url, {
            deleteExisting: true
        });
    }

    $.ajax({
        url: url,
        type: 'GET',
        dataType: 'json',
        data: $form.serialize(),
        success: function (data) {
            if (data.error) {
                $('.promo-code-form .form-control').addClass('is-invalid');
                $('.promo-code-form .form-control').attr('aria-describedby', 'invalidCouponCode');
                $('.coupon-error-message').empty().append(data.errorMessage);
                $('.promo-code-form .form-control').focus();
                $('.promo-code-form label[for="couponCode"]').addClass('invalid-label');
            } else if (data.showCouponInterceptModal) {
                // Show Coupon Modal Intercept
                $('#couponInterceptModal').modal('show');
            } else {
                // Coupon added successfully but if it's invalid for current basket, remove
                var invalidCouponsRemoved = removeCartInvalidCoupon(data);
                if (invalidCouponsRemoved) return;

                updateCartTotals(data);
                $('#coupon-code-input-modal').modal('hide');
                $('.add-coupon-link').attr('disabled', true);
            }
            $.spinner().stop();
        },
        error: function (err) {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            } else {
                showToast(err.errorMessage, 'danger');
                $.spinner().stop();
            }
        }
    });
}

module.exports = function () {
    $('body').on('click', '.remove-product', function (e) {
        e.preventDefault();

        var actionUrl = $(this).data('action');
        var productID = $(this).data('pid');
        var productName = $(this).data('name');
        var uuid = $(this).data('uuid');
        confirmDelete(actionUrl, productID, productName, uuid);
    });

    $('body').on('afterRemoveFromCart', function (e, data) {
        e.preventDefault();
        confirmDelete(data.actionUrl, data.productID, data.productName, data.uuid);
    });

    $('body').on('click', '.cart-delete-confirmation-btn', function (e) {
        e.preventDefault();
        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var isMiniCart = $(this).data('is-minicart');

        var urlParams = {
            pid: productID,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        $.spinner().start();
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                $.spinner().stop();
                // do not refresh the page if we are deleting from the minicart
                if (isMiniCart) {
                    if (data.basket.items.length === 0) {
                        $('.cart').empty().append('<div class="row"> ' +
                            '<div class="col-12 text-center"> ' +
                            '<h1>' + data.basket.resources.emptyCartMsg + '</h1> ' +
                            '</div> ' +
                            '</div>'
                        );
                        $('.number-of-items').empty().append(data.basket.resources.numberOfItems);
                        $('.minicart-quantity').empty().append(data.basket.numItems);
                        $('.minicart-link').attr({
                            'aria-label': data.basket.resources.minicartCountOfItems,
                            title: data.basket.resources.minicartCountOfItems
                        });
                        $('.minicart .popover').empty();
                        $('.minicart .popover').removeClass('show');
                        $('body').removeClass('modal-open');
                        $('html').removeClass('veiled');
                    } else {
                        if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
                            for (var i = 0; i < data.toBeDeletedUUIDs.length; i++) {
                                $('.uuid-' + data.toBeDeletedUUIDs[i]).remove();
                            }
                        }
                        $('.uuid-' + uuid).remove();
                        if (!data.basket.hasBonusProduct) {
                            $('.bonus-product').remove();
                        }
                        $('.coupons-and-promos').empty().append(data.basket.totals.discountsHtml);
                        updateCartTotals(data.basket);
                        updateApproachingDiscounts(data.basket.approachingDiscounts);
                        $('body').trigger('setShippingMethodSelection', data.basket);
                        validateBasket(data.basket);
                        updateCheckoutButtons(data.basket);
                    }
                    $('body').trigger('product:afterRemoveFromCart', data);
                    $('body').trigger('cart:update');
                } else {
                    location.replace(utils.appendParamToURL(location.href, 'showIntercept', false));
                }
            },
            error: function (err) {
                if (err.responseJSON && err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('body').on('change', '.quantity-form > .quantity', function () {
        var preSelectQty = $(this).data('pre-select-qty');
        var quantity = $(this).val();
        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');

        var urlParams = {
            pid: productID,
            quantity: quantity,
            uuid: uuid
        };
        url = appendToUrl(url, urlParams);

        $(this).parents('.card').spinner().start();

        $.ajax({
            url: url,
            type: 'get',
            context: this,
            dataType: 'json',
            mode: 'cors',
            success: function (data) {
                /**
                 * if we updated the qty of a product that would potentially require recycling fees
                 * refresh the page so that all recycling fee products are updated
                 */
                if ($(this).parents('.product-info').hasClass('subject-to-recycling-fee')) {
                    location.replace(utils.appendParamToURL(location.href, 'showIntercept', false));
                    return;
                }

                $('.quantity[data-uuid="' + uuid + '"]').val(quantity);
                $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                updateCartTotals(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                updateAvailability(data, uuid);
                validateBasket(data);
                updateCheckoutButtons(data);
                $(this).data('pre-select-qty', quantity);

                $('body').trigger('cart:update');

                $.spinner().stop();
                if ($(this).parents('.product-info').hasClass('bonus-product-line-item') && $('.cart-page').length) {
                    location.replace(utils.appendParamToURL(location.href, 'showIntercept', false));
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $(this).val(parseInt(preSelectQty, 10));
                    $.spinner().stop();
                }
            }
        });
    });

    $('.shippingMethods').change(function () {
        var url = $(this).attr('data-actionUrl');
        var urlParams = {
            methodID: $(this).find(':selected').attr('data-shipping-id')
        };
        // url = appendToUrl(url, urlParams);

        $('.totals').spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: urlParams,
            success: function (data) {
                if (data.error) {
                    window.location.href = data.redirectUrl;
                } else {
                    $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                    updateCheckoutButtons(data);
                    updateEDD(data);
                }
                $.spinner().stop();
            },
            error: function (err) {
                if (err.redirectUrl) {
                    window.location.href = err.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $(function () {
        if ($('#shippingCountrydefault').val() === 'Canada') {
            $('#shippingZipCodedefault').bind('input', function () {
                var shippingZipCodeLength = $('#shippingZipCodedefault').val().length;
                if (shippingZipCodeLength >= 4) {
                    $(this).val(function (_, v) {
                        return v.replace(/\W/g, '').replace(/(...)/, '$1 ');
                    });
                }
            });
        } else if ($('#shippingCountrydefault').val() === 'United States') {
            $('#shippingZipCodedefault, #billingZipCode').bind('input', function () {
                $(this).val(function (_, v) {
                    return v.replace(/\s+/g, '');
                });
            });
        }
    });

    $(function () {
        $('#couponCode').bind('input', function () {
            $(this).val(function (_, v) {
                return v.replace(/\s+/g, '');
            });
            const hasInput = $(this).val().trim().length > 0;
            $('.promo-code-btn').prop('disabled', !hasInput);
        });

        if ($('.delete-coupon-confirmation-btn').length > 0) {
            $('.add-coupon-link').attr('disabled', true);
        }
    });

    $('.promo-code-form').submit(function (e) {
        e.preventDefault();
        $.spinner().start();
        $('.coupon-missing-error').hide();
        $('.coupon-error-message').empty();
        if (!$('.coupon-code-field').val()) {
            $('.promo-code-form .form-control').addClass('is-invalid');
            $('.promo-code-form .form-control').attr('aria-describedby', 'missingCouponCode');
            $('.coupon-missing-error').show();
            $.spinner().stop();
            $('.promo-code-form .form-control').focus();
            return false;
        }
        submitAddCartCoupon(true);
        return false;
    });

    $('body').on('click', '.btn-coupon-intercept-delete', function (e) {
        e.preventDefault();
        $('body > .modal-backdrop').remove();
        $('#couponInterceptModal').modal('hide');
        $.spinner().start();
        submitAddCartCoupon(true);
    });

    $('body').on('click', '.btn-coupon-intercept-cancel', function (e) {
        e.preventDefault();
        $('body > .modal-backdrop').remove();
        $('#couponInterceptModal').modal('hide');
        $('.coupon-code-field').val('');
    });

    $('body').on('click', '.remove-coupon', function (e) {
        e.preventDefault();

        var couponCode = $(this).data('code');
        var uuid = $(this).data('uuid');
        var $deleteConfirmBtn = $('.delete-coupon-confirmation-btn');
        var $productToRemoveSpan = $('.coupon-to-remove');

        $deleteConfirmBtn.data('uuid', uuid);
        $deleteConfirmBtn.data('code', couponCode);

        $productToRemoveSpan.empty().append(couponCode);
    });

    $('body').on('click', '.delete-coupon-confirmation-btn', function (e) {
        e.preventDefault();

        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var couponCode = $(this).data('code');
        var urlParams = {
            code: couponCode,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        $.spinner().start();
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                $('.coupon-uuid-' + uuid).remove();
                $('.js-cart-promo-code').empty();
                updateCartTotals(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                validateBasket(data);
                updateCheckoutButtons(data);
                $.spinner().stop();
                showToast(data.resources.couponRemovedSuccessMsg, 'success');
                $('.add-coupon-link').attr('disabled', false);
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    showToast(err.responseJSON.errorMessage, 'danger');
                    $.spinner().stop();
                }
            }
        });
    });

    $('body').on('click', '.cart-page .bonus-product-button', function () {
        $.spinner().start();
        $(this).addClass('launched-modal');
        $.ajax({
            url: $(this).data('url'),
            method: 'GET',
            dataType: 'json',
            success: function (data) {
                base.methods.editBonusProducts(data);
                $('.bonus-product-item').each(function () {
                    var bonusItem = $(this);
                    imagesloaded(bonusItem).on('done', function () {
                        carouselsBonusProduct.quickviewCarousel();
                    });
                });
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
        $('#chooseBonusProductModal').remove();
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');

        if ($('.cart-page').length) {
            $('.launched-modal .btn-outline-primary').trigger('focus');
            $('.launched-modal').removeClass('launched-modal');
        } else {
            $('.product-detail .add-to-cart').focus();
        }
    });

    $('body').on('click', '.cart-page .product-edit .edit, .cart-page .bundle-edit .edit', function (e) {
        e.preventDefault();

        var editProductUrl = $(this).attr('href');
        getModalHtmlElement();
        fillModalElement(editProductUrl);
    });

    $('body').on('shown.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'true');
        $('#editProductModal .close').focus();
    });

    $('body').on('hidden.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'false');
    });

    $('body').on('keydown', '#editProductModal', function (e) {
        var focusParams = {
            event: e,
            containerSelector: '#editProductModal',
            firstElementSelector: '.close',
            lastElementSelector: '.update-cart-product-global',
            nextToLastElementSelector: '.modal-footer .quantity-select'
        };
        focusHelper.setTabNextFocus(focusParams);
    });

    $('body').on('product:updateAddToCart', function (e, response) {
        // update global add to cart (single products, bundles)
        var dialog = $(response.$productContainer)
            .closest('.quick-view-dialog');

        $('.update-cart-product-global', dialog).attr('disabled',
            !$('.global-availability', dialog).data('ready-to-order')
            || !$('.global-availability', dialog).data('available')
            || !$('.global-availability', dialog).data('sellable')
        );
    });

    $('body').on('product:updateAvailability', function (e, response) {
        // bundle individual products
        $('.product-availability', response.$productContainer)
            .data('ready-to-order', response.product.readyToOrder)
            .data('available', response.product.available)
            .data('sellable', response.product.sellable)
            .find('.availability-msg')
            .empty()
            .html(response.message);


        var dialog = $(response.$productContainer)
            .closest('.quick-view-dialog');

        if ($('.product-availability', dialog).length) {
            // bundle all products
            var allAvailable = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('available'); });

            var allReady = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('ready-to-order'); });

            var allSellable = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('sellable'); });

            $('.global-availability', dialog)
                .data('ready-to-order', allReady)
                .data('available', allAvailable)
                .data('sellable', allSellable);

            $('.global-availability .availability-msg', dialog).empty()
                .html(allReady ? response.message : response.resources.info_selectforstock);
        } else {
            // single product
            $('.global-availability', dialog)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .data('sellable', response.product.sellable)
                .find('.availability-msg')
                .empty()
                .html(response.message);
        }
    });

    $('body').on('product:afterAttributeSelect', function (e, response) {
        if ($('.modal.show .product-quickview .bundle-items').length) {
            $('.modal.show').find(response.container).data('pid', response.data.product.id);
            $('.modal.show').find(response.container).find('.product-id').text(response.data.product.id);
        } else {
            $('.modal.show .product-quickview').data('pid', response.data.product.id);
        }
    });

    $('body').on('change', '.quantity-select', function () {
        var selectedQuantity = $(this).val();
        $('.modal.show .update-cart-url').data('selected-quantity', selectedQuantity);
    });

    $('body').on('click', '.update-cart-product-global', function (e) {
        e.preventDefault();

        var updateProductUrl = $(this).closest('.cart-and-ipay').find('.update-cart-url').val();
        var selectedQuantity = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-quantity');
        var uuid = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('uuid');

        var form = {
            uuid: uuid,
            pid: base.getPidValue($(this)),
            quantity: selectedQuantity
        };

        $(this).parents('.card').spinner().start();
        if (updateProductUrl) {
            $.ajax({
                url: updateProductUrl,
                type: 'post',
                context: this,
                data: form,
                dataType: 'json',
                success: function (data) {
                    $('#editProductModal').modal('hide');

                    $('.coupons-and-promos').empty().append(data.cartModel.totals.discountsHtml);
                    updateCartTotals(data.cartModel);
                    updateApproachingDiscounts(data.cartModel.approachingDiscounts);
                    updateAvailability(data.cartModel, uuid);
                    updateProductDetails(data, uuid);

                    if (data.uuidToBeDeleted) {
                        $('.uuid-' + data.uuidToBeDeleted).remove();
                    }

                    validateBasket(data.cartModel);
                    updateCheckoutButtons(data);

                    $('body').trigger('cart:update');

                    $.spinner().stop();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                }
            });
        }
    });

    $('body').on('click', '.donationAmount', function () {
        $(this).closest('.radio-block-group').find('.donationAmount').removeClass('active')
            .attr('aria-current', 'false');
        $(this).addClass('active').attr('aria-current', 'true');
        var $addToCart = $('.pet-donation-add-to-cart');
        $addToCart.removeAttr('disabled');
        var selectedAmount = $(this).val();
        requestAnimationFrame(function () {
            $addToCart.attr('aria-label', 'Add ' + selectedAmount + ' donation to cart');
            requestAnimationFrame(function () {
                $addToCart.trigger('focus');
            });
        });
    });

    $('body').on('click', '.pet-donation-add-to-cart', function (e) {
        e.preventDefault();

        $(this).spinner().start();
        var addToCartUrl = $('.add-to-cart-url').val();
        var $productContainer = $(this).closest('.product-detail');
        var donationOptions = JSON.parse(getDonationOptions($productContainer));
        var pid = donationOptions ? donationOptions[0].selectedValueId : '';

        var form = {
            pid: pid,
            quantity: 1,
            options: donationOptions
        };

        if (addToCartUrl) {
            $.ajax({
                url: addToCartUrl,
                method: 'POST',
                data: form,
                success: function () {
                    $(this).spinner().stop();

                    if ($('[js-hook-shipping-form]:visible').length > 0) {
                        window.onbeforeunload = () => {
                            var tempContact = {
                                inputShippingFirstName: $('[js-hook-input-shipping-first-name]').val(),
                                inputShippingLastName: $('[js-hook-input-shipping-last-name]').val(),
                                inputShippingEmail: $('[js-hook-input-shipping-email]').val(),
                                inputShippingPhone: $('[js-hook-input-shipping-phone]').val()
                            };
                            localStorage.setItem('dwfrm_temp_contact', btoa(JSON.stringify(tempContact)));
                        };
                    }

                    location.reload();
                },
                error: function () {
                    $(this).spinner().stop();
                }
            });
        }
    });
    var htmlString = '<!-- Content Asset Modal -->'
        + '<div class="modal fade" id="contentModal" tabindex="-1" role="dialog" aria-hidden="true">'
        + '<div class="modal-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header"><div class="header-label"></div><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>'
        + '<div class="modal-body"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
    var $modal = $('#contentModal');
    $modal.modal({ show: false });
    $modal.on('shown.bs.modal', function (e) {
        if ($('.modal-header .header-label').is(':empty')) {
            if ($(e.relatedTarget).data('title')) {
                $(this).find('.modal-header .header-label').append($(e.relatedTarget).data('title'));
            }
        }
        if ($('.modal-body').is(':empty')) {
            $.spinner().start();
            var loadurl = $(e.relatedTarget).attr('href') + '&ajax=true #maincontent *';
            $(this).find('.modal-body').load(loadurl, function () {
                $.spinner().stop();
                $modal.modal({ show: true });
            });
        }
    });

    $('body').on('click', '.zipcode-submit', function (e) {
        e.preventDefault();
        $.spinner().start();

        var $form = $('.zipcode-form');
        var url = $form.attr('action');

        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                if (data.error) {
                    // display error message
                    var errorHtml = '<div class="alert alert-danger alert-dismissible fade show" role="alert">' +
                                        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
                                            '<span aria-hidden="true">×</span>' +
                                        '</button>' +
                                        data.error +
                                    '</div>';

                    $('.zipcode-field-error').removeClass('hide');
                    $('.zipcode-field-error').append(errorHtml);
                } else {
                    updateEDD(data);
                    // Update displayed zip code
                    $('.customer-zipcode-input').empty().append(data.narvarEDD.customerZipcode);

                    // show entered zip container without page reload
                    $('.zipcode-set-container').addClass('show-zipcode-edd-info');

                    // Hide input without page reload
                    $('.zipcode-reset-container').addClass('hide-zipcode-input-field');

                    // show/hide EDDs per line
                    data.data.items.forEach(function (item) {
                        var eddContainerSelector = '.product-line-estimated-delivery-container.edd-item-' + item.UUID;
                        if (item.isPetDonationProduct) {
                            $(eddContainerSelector).removeClass('show-zipcode-edd-info');
                        } else {
                            $(eddContainerSelector).addClass('show-zipcode-edd-info');
                        }
                    });
                }

                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON && err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    $.spinner().stop();
                }
            }
        });
    });

    $('body').on('click', '.zipcode-reset', function () {
        if ($('.zipcode-reset-container').hasClass('hide-zipcode-input-field')) {
            $('.zipcode-reset-container').removeClass('hide-zipcode-input-field');
        }
    });

    $('body').on('click', '.zipcode-cancel-btn', function () {
        if (!$('.zipcode-reset-container').hasClass('hide-zipcode-input-field')) {
            $('.zipcode-reset-container').addClass('hide-zipcode-input-field');
        }
    });

    base.selectAttribute();
    base.colorAttribute();
    base.removeBonusProduct();
    base.selectBonusProduct();
    base.enableBonusProductSelection();
    base.showMoreBonusProducts();
    base.addBonusProductsToCart();
    base.focusChooseBonusProductModal();
    base.trapChooseBonusProductModalFocus();
    base.onClosingChooseBonusProductModal();
    recommendationIntercept.methods.showCartIntercept();
};
